import Api from "@/config/Api";

export default {
  getNotifications(filter = "all") {
    return Api().get("/me/notifications", { params: { filter } });
  },

  getBadge() {
    return Api().get("/me/notifications/badge");
  },

  markRead(ids) {
    if (ids === "all") {
      return Api().post("/me/notifications/read", { all: true });
    }
    return Api().post("/me/notifications/read", { ids });
  },

  dismiss(id) {
    return Api().post(`/me/notifications/${id}/dismiss`);
  },

  sync() {
    return Api().post("/me/notifications/sync");
  }
};
